import React, { useContext } from "react";
import { LegacyCard as Card, Collapsible, Text, Layout, BlockStack } from "@shopify/polaris";
import { DropZone } from "lib/components";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const WelcomeCover = () => {
  const { ONBOARD_IMAGE_TYPE, WELCOME_COVER } = constant;
  const { handleChange, welcomeCoverImage } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { brand } = currentUser || {};
  const { welcome, updatedAt: brandUpdatedAt = "" } = brand || {};
  const { cover: welcomeCover } = welcome || {};
  const { updatedAt = "" } = welcomeCover || {};
  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.welcomeCover.title")}
        description={cms("section.welcomeCover.description")}
      >
        <Card
          title={[
            cms("section.welcomeCover.card.title"),
            updatedAt ? (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
              </Text>
            ) : (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(brandUpdatedAt)}`}</Text>
              </Text>
            ),
          ]}
        >
          <Card.Section>
            <BlockStack gap="2">{cms("section.welcomeCover.card.subDescription")}</BlockStack>
            <br />
            <DropZone
              id="dropZone"
              size={10}
              allowedTypes={ONBOARD_IMAGE_TYPE}
              onAdd={(value) => handleChange(WELCOME_COVER, (value && value.length && value[0]) || "", WELCOME_COVER)}
              onRemove={() => handleChange(WELCOME_COVER, "", WELCOME_COVER)}
              fileList={(welcomeCoverImage !== "" && [welcomeCoverImage]) || []}
              allowMultiple={false}
            />
            <br />
            <Text variant="bodySm" as="p">
              {cms("section.welcomeCover.card.caption")}
            </Text>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withFeature(withErrorBoundary(WelcomeCover), {
  feature: constant.STANDARD_BRANDING,
});
